import * as React from 'react'
import Chip from '@mui/material/Chip'
import Avatar from '@mui/material/Avatar'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

interface ChipWithProgressProps {
  label: string;
  progress: number; // Value between 0 and 100
}

export const ChipWithProgress: React.FC<ChipWithProgressProps> = ({ label, progress }) => {
  return (
    <Chip
      label={label}
      avatar={
        <Avatar sx={{ position: 'relative', width: 30, height: 30 }}>
          <CircularProgress
            variant="determinate"
            value={progress}
            size={25}
            thickness={4}
            sx={{
              position: 'absolute',
              color: (theme) => (progress < 100 ? theme.palette.primary.main : theme.palette.success.main),
              zIndex: 1,
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              fontSize: '0.6rem', // Smaller font size for percentage
              color: 'text.primary',
            }}
          >
            {progress}%
          </Box>
        </Avatar>
      }
      sx={{
        pr: 1.5, // Padding right for the percentage text to be visible
      }}
      size='medium'
    />
  )
}